// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".maintenance-alert[data-v-2cce360b]{position:fixed;bottom:20px;left:20px;max-width:600px;min-width:480px;padding:24px;font-size:16px;z-index:9999}.maintenance-title[data-v-2cce360b]{font-size:20px;font-weight:600;margin-bottom:8px}.maintenance-body[data-v-2cce360b]{font-size:15px;line-height:1.5}", ""]);
// Exports
module.exports = exports;
